
import React, { useEffect } from "react";
import { Spinner } from "@sapphire-react/lab";
import * as styles from './HomeComponent.style'
import { useNavigate, useParams } from "react-router-dom";
import { Variables } from "../../api/utils/endpoints";

const HomeComponent = () => {
  const { language } = useParams();
  const navigate = useNavigate();
  const allowedLanguages = Variables.allowedLanguageArray;
  const defaultLanguage = Variables.finnishLanguageCode;
  useEffect(() => {
    if(language && !allowedLanguages.includes(language)) {
        navigate(`/${defaultLanguage}` , {replace : true})
    }
  } , [language , navigate, allowedLanguages, defaultLanguage])
  return (
    <div style={styles.mainDiv}>
      <Spinner aria-label="Loading..." size="xl" margin="auto" />
    </div>
  );
};


export default HomeComponent;